import { coreApi } from '../../utils/axios';
import { CreateClinicMasterProductResponse, GetClinicMasterProductResponse, GetClinicMasterProductsResponse, ClinicMasterProduct } from './types';

export const getClinicMasterProducts = (clinicId: string, page: number, limit: number) => {
  return coreApi.get<GetClinicMasterProductsResponse>(`/clinic-master-products?clinicId=${clinicId}&page=${page}&limit=${limit}`);
};

export const updateClinicMasterProduct = (id: string, data: Partial<ClinicMasterProduct>) => {
  return coreApi.put(`/clinic-master-products/${id}`, data);
};

export const getClinicMasterProduct = (id: string) => {
  return coreApi.get<GetClinicMasterProductResponse>(`/clinic-master-products/${id}`);
};

export const createClinicMasterProduct = (data: Partial<ClinicMasterProduct>) => {
  return coreApi.post<CreateClinicMasterProductResponse>('/clinic-master-products', data);
}

export const deleteClinicMasterProduct = (id: string) => {
  return coreApi.delete(`/clinic-master-products/${id}`);
}
